import FuseUtils from '@fuse/utils';
import AdminRouteConfig from 'app/main/apps/admin/AdminConfig';
import appsConfigs from 'app/main/apps/appsConfigs';
import CgvPageConfig from 'app/main/apps/cgu/CgvPageConfig';
import MyBrandsPageConfig from 'app/main/apps/myBrands/MyBrandsPageConfig';
import UsersManagementRouteConfig from 'app/main/apps/usersManagement/UsersManagementRouteConfig';
import LoginConfig from 'app/main/login/LoginConfig';
import LogoutConfig from 'app/main/logout/LogoutConfig';
import MobilePageConfig from 'app/main/mobile/MobilePageConfig';
import { currentViewMode } from 'app/main/mobile/viewMode';
import NoStoresPageConfig from 'app/main/pages/noStores/NoStoresPageConfig';
import { ForbiddenPageConfig, pagesConfigs, paidPagesConfigs } from 'app/main/pages/pagesConfigs';
import ValidationPageConfig from 'app/main/pages/validation/ValidationPageConfig';
import UserInterfaceConfig from 'app/main/user-interface/UserInterfaceConfig';
import PosPageConfig from 'app/pos/PosPageConfig';
import { isFeatureFlagEnabled } from 'app/utils/featureFlags.utils';
import React from 'react';
import { Redirect } from 'react-router-dom';
import authRoles from '../auth/authRoles';
import { routesUrl } from './navigationConfig';

export const RootPageComponent = () => {
  if (currentViewMode() === 'mobile') {
    return <Redirect to={routesUrl.mobileHome} />;
  }

  // The home page replaces the start page preference: merchants land on it every time.
  if (isFeatureFlagEnabled('home')) {
    return <Redirect to={routesUrl.home} />;
  }

  const redirectionUrl = localStorage.getItem('startPageUrl') || routesUrl.analytics;

  return <Redirect to={redirectionUrl} />;
};

const routeConfigs = [
  ...appsConfigs,
  ...pagesConfigs,
  UserInterfaceConfig,
  LogoutConfig,
  LoginConfig,
  CgvPageConfig,
  PosPageConfig,
];

const routes = [
  // if you want to make whole app auth protected by default change defaultAuth for example:
  // The individual route configs which has auth option won't be overridden.
  ...FuseUtils.generateRoutesFromConfigs([ForbiddenPageConfig]),
  ...FuseUtils.generateRoutesFromConfigs([ValidationPageConfig], authRoles.registered),
  ...FuseUtils.generateRoutesFromConfigs([NoStoresPageConfig], authRoles.noStores),
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, authRoles.owner),
  ...FuseUtils.generateRoutesFromConfigs(paidPagesConfigs, authRoles.owner),
  ...FuseUtils.generateRoutesFromConfigs([MobilePageConfig], authRoles.owner),
  ...FuseUtils.generateRoutesFromConfigs([AdminRouteConfig]),
  ...FuseUtils.generateRoutesFromConfigs([UsersManagementRouteConfig], authRoles.fullAccess),
  ...FuseUtils.generateRoutesFromConfigs([MyBrandsPageConfig], authRoles.brandPicker),
  {
    path: routesUrl.login,
    exact: true,
    auth: null,
    component: LoginConfig,
  },
  {
    path: routesUrl.scanner,
    exact: true,
    component: React.lazy(() => import('app/main/apps/scanner/components/ScannerPage')),
  },
  // called for "/" route
  {
    component: RootPageComponent,
  },
];

export default routes;
